<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="entryFormName+ ' [Custom Forms] :: MeritEHS'"/>

            <div class="container d-print-none">
                <h4 class="py-3 mb-4">
                    <ol class="breadcrumb font-weight-bold m-0">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/custom-forms`">
                                <i class="fa fa-check-square-o"></i> Custom Forms
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/custom-forms/entry/view/${entry.id}`">
                                {{ entryFormName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            <i class="fa fa-file-pdf-o"></i> PDF
                        </li>
                    </ol>
                </h4>
            </div>
            <div class="container bg-white d-print-none py-4 mb-4">
                <div class="alert alert-info">
                    <strong>How to Export as PDF:</strong>
                    <ol>
                        <li>On your browser, there should be a "File" or "Options" tab with a "Print" option. You may also hold down the "Ctrl" key and press the "P" key.</li>
                        <li>This will bring up the print page options box. There should be an option called "Select Printer" or "Destination".</li>
                        <li>Select "Save as PDF" or "Adobe PDF".</li>
                        <li>Click "Save" or "Print". This will open your file explorer and let you save it to your computer as a PDF.</li>
                    </ol>

                    <div>
                        <strong>PDF Settings:</strong>
                        <ol>
                            <li class="mb-1">
                                <span>Show/Hide Logo</span>
                                <select v-model="showLogo">
                                    <option :value="true">Show Logo</option>
                                    <option :value="false">Hide Logo</option>
                                </select>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

            <div class="container bg-white py-4">

                <div class="row" v-if="pdfLogo && showLogo === true" style="margin-bottom: 50px;">
                    <div class="col-3">
                        <img :src="pdfLogo" class="img-fluid" />
                    </div>
                </div>

                <h5 class="page-header">Custom Form Entry</h5>
                <div class="row">
                    <div class="col-6">
                        <div class="row mb-2">
                            <div class="col-5 text-muted">Form Name:</div>
                            <div class="col-7">
                                {{ entry.covid_form_name }}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 text-muted">Completed By:</div>
                            <div class="col-7">
                                <span v-if="entry.employee_id">{{ entry.FirstName }} {{ entry.LastName }}</span>
                                <span v-else>{{ entry.person_name }}</span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 text-muted">Date Completed:</div>
                            <div class="col-7">
                                {{ entry.created_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 text-muted">Jobsite:</div>
                            <div class="col-7">
                                <span v-if="entry.jobsite_id">{{ entry.JobsiteNumber }} - {{ entry.JobsiteName }}</span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-5 text-muted">Status:</div>
                            <div class="col-7">
                                <h5 :class="'text-'+(entry.entry_status == 'Open' ? 'danger' : 'success')">{{ entry.entry_status }}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <img ref="signatureFile" src="" class="img-fluid" v-if="entry.signature_file_id" />
                    </div>
                </div>
                <hr/>

                <div v-if="personnel.length > 0">
                    <h5>Personnel ({{ personnel.length }}):</h5>
                    <div class="row mb-2" v-for="person in personnel">
                        <div class="col-3 text-muted">{{ person.field_label }}:</div>
                        <div class="col-7">
                            <span v-if="person.employee_id">
                                {{ person.employee_first_name }} {{ person.employee_last_name }} - {{ person.EmployeeNumber }}
                            </span>
                            <span v-else>
                                {{ person.other_personnel_name }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="break-protect" style="margin-top: 50px;" v-for="section in sections">
                    <h5 class="page-header" v-if="section.section_name">
                        {{ section.section_name }}
                    </h5>

                    <div v-for="field in section.fields">
                        <div class="row mb-2" v-if="field.type != 'Paragraph' && field.type != 'Heading' && (field.parent_field_id == null || (field.parent_field_id != null && field.value))">
                            <div class="col-3 text-muted">
                                {{ field.label }}:
                            </div>
                            <div class="col-7">
                                <template v-if="field.value == null">

                                </template>

                                <template v-else-if="field.type == 'Radio'">
                                    {{ field.options[field.value] }}
                                </template>

                                <template v-else-if="field.type == 'Checkbox' && field.value">
                                    <span v-for="(val, i) in field.value">
                                        <span v-if="i > 0">, </span>{{ field.options[val] }}
                                    </span>
                                </template>

                                <template v-else-if="field.type == 'Date'">
                                    {{ field.value | moment("MM/DD/YYYY") }}
                                </template>

                                <template v-else-if="field.type == 'Textarea'">
                                    <div v-html="field.value"></div>
                                </template>

                                <template v-else-if="field.type == 'Employee'">
                                    {{ field.value.EmployeeNumber }} - {{ field.value.FirstName }} {{ field.value.LastName }}
                                </template>

                                <template v-else-if="field.type == 'Equipment'">
                                    {{ field.value.equipment_type_name }} - {{ field.value.serial_number }} <span v-if="field.value.equipment_name">{{ field.value.equipment_name }}</span>
                                </template>

                                <template v-else-if="field.type == 'Jobsite'">
                                    {{ field.value.JobsiteNumber }} - {{ field.value.JobsiteName }}
                                </template>

                                <template v-else-if="field.type == 'User'">
                                    {{ field.value.FirstName }} {{ field.value.LastName }}
                                </template>

                                <template v-else-if="field.type == 'File'">
                                    <template v-if="Array.isArray(field.value)">
                                        <div class="text-center" style="margin-bottom: 25px;" v-for="file in files">
                                            <img v-bind:src="getThumbnail(file)" class="img-fluid" :ref="`file-${file.file_id}`">
                                            <div class="text-muted small">
                                                <strong class="project-attachment-filename" style="color: #333;">{{ file.file_name }}</strong><br/>
                                                {{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ file.FirstName }} {{ file.LastName }}
                                            </div>
                                            <hr class="d-print-none" />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="text-center" style="margin-bottom: 25px;">
                                            <img v-bind:src="getThumbnail(field.value)" class="img-fluid" :ref="`file-${field.value.file_id}`">
                                            <div class="text-muted small">
                                                <strong class="project-attachment-filename" style="color: #333;">{{ field.value.file_name }}</strong><br/>
                                                {{ field.value.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ field.value.FirstName }} {{ field.value.LastName }}
                                            </div>
                                            <hr class="d-print-none" />
                                        </div>
                                    </template>
                                </template>

                                <template v-else-if="Array.isArray(field.value)" v-for="(val, key) in field.value">
                                    <span v-if="key > 0">, </span>{{ val }}
                                </template>

                                <template v-else>{{ field.value }}</template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                loading: true,
                entry_id: this.$route.params.id,
                entry: {},
                files: [],
                covid_fields: [],
                personnel: [],
                showLogo: true,
                pdfLogo: null,
                imagesLoading: false,
                pdfs_proccessing: false,
            }
        },

        computed: {

            entryFormName(){
                //Setup
                var name = this.entry.covid_form_name + ' - ';

                //Check Employee ID
                if(this.entry.employee_id)
                {
                    name += this.entry.FirstName + ' ' + this.entry.LastName;
                }
                else
                {
                    //Append
                    name += this.entry.person_name;
                }

                //Append the Date
                name += ' - '+this.entry.created_at;

                //Send it
                return name;
            },

            images(){
                //Make sure we only pass images
                var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

                //Setup
                var imageFiles = [];

                //loop
                for(var i in this.files)
                {
                    if(types.indexOf(this.files[i].file_extension.toLowerCase()) !== -1)
                    {
                        imageFiles.push(this.files[i]);
                    }
                }

                //Send it
                return imageFiles;
            },

            nonImages(){
                //Make sure we only pass images
                var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

                //Setup
                var files = [];

                //loop
                for(var i in this.files)
                {
                    if(types.indexOf(this.files[i].file_extension.toLowerCase()) === -1)
                    {
                        files.push(this.files[i]);
                    }
                }

                //Send it
                return files;
            },

            sections(){
                //Setup
                var covid_fields = [];

                //Loop through and build lists
                for(var i = 0; i < this.covid_fields.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.covid_fields[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    covid_fields.push(sec);
                }

                //Send it
                return covid_fields;
            },
        },

        methods: {

            //Get the thumbnail preview
            getThumbnail(file){
                var preview = null;

                //Switch
                switch(file.file_extension)
                {
                    case 'pdf':
                        preview = '/Images/file-type-pdf_256x256.png';
                        break;
                    case 'docx':
                    case 'doc':
                        preview = '/Images/file-type-docx_256x256.png';
                        break;
                    case 'xls':
                    case 'xlsx':
                        preview = '/Images/file-type-xlsx_256x256.png';
                        break;
                    default:
                        //Data should be a path, not a string - we converted those
                        // $path = $this->{$imageDataName};
                        // $type = pathinfo($path, PATHINFO_EXTENSION);
                        // $data = Storage::get($path);
                        // $preview = "data:image/".$type.";base64," . base64_encode($data);
                        this.loadThumbnail(file);

                        //Stop here
                        return '';
                        break;
                }

                //Stop here
                return preview;

                //Set the preview
                //this.$refs['file-' + file.file_id][0].src = preview;
            },

            loadThumbnail(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + file.file_id][0].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },

            getCustomForm() {
                //Get the data
                this.$http
                    .get('custom-forms/entry/view/' + this.entry_id + '?pdf=true')
                    .then(response => {
                        //Set all the data
                        this.entry = response.data.entry;
                        this.personnel = response.data.personnel;
                        this.files = response.data.files;
                        this.pdfLogo = response.data.pdfLogo;
                        this.pdfs_proccessing = response.data.pdfs_proccessing;

                        //Setup Sections
                        this.covid_fields = typeof this.entry.covid_fields == 'string' ? JSON.parse(this.entry.covid_fields) : this.entry.covid_fields;

                        //Load the sig
                        if(this.entry.signature_file_id)
                        {
                            //Load it
                            this.loadSignature(this.entry.signature_file_id);
                        }
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            reloadImages(){
                //Reset the flag
                this.imagesLoading = true;

                //Send it
                this.$http
                    .get('incident/images/' + this.entry_id)
                    .then(response => {
                        //Set the data
                        this.files = response.data.images;
                        this.pdfs_proccessing = response.data.pdfs_proccessing;

                        //Alert
                        this.$toastr.success('Files & Photos Reloaded');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset the flag
                        this.imagesLoading = false;
                    });
            },

            loadSignature(signature_file_id){
                //Send it
                this.$http.get('files/view/'+signature_file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs.signatureFile.src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });

                //Need to return null so it fills the source
                return null;
            },
        },
        mounted() {
            //Get the custom-forms
            this.getCustomForm();
        }
    }
</script>
<style>
    .break-protect {
        break-inside: auto;
    }
    .body {
        margin: 25mm;
    }
    @page {
        margin-top: 1in;
        margin-bottom: 1in;
    }
</style>